/**
 * Top status rail — live telemetry for the current scene.
 * Exposes initStatusRail() + updateRail() called from the render loop.
 */

const state = {
  els: null,
  mode: 'alive',
}

function el(id) { return document.getElementById(id) }

export function initStatusRail({ renderer } = {}) {
  state.els = {
    mode: el('rail-mode'),
    cats: el('rail-cats'),
    fps: el('rail-fps'),
    gen: el('rail-gen'),
    time: el('rail-time'),
    footerYear: el('footer-year'),
  }
  if (renderer) state.mode = renderer
  if (state.els.mode) state.els.mode.textContent = state.mode
  if (state.els.footerYear) state.els.footerYear.textContent = String(new Date().getFullYear())

  setInterval(tickClock, 1000)
  tickClock()
}

function pad2(n) { return String(n).padStart(2, '0') }

function tickClock() {
  if (!state.els?.time) return
  const d = new Date()
  state.els.time.textContent = `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`
}

export function updateRail({ cats, fps, generation }) {
  if (!state.els) return
  if (state.els.cats && typeof cats === 'number') {
    state.els.cats.textContent = pad2(Math.min(99, cats))
  }
  if (state.els.fps && typeof fps === 'number') {
    state.els.fps.textContent = String(fps).padStart(2, '0')
  }
  if (state.els.gen && typeof generation === 'number') {
    state.els.gen.textContent = pad2(Math.min(99, generation))
  }
}
